<template>
    <layout class="text-white">
        <section-hero :section-hero="sectionHero" />
        <section-values :section-values="sectionValues" />
        <section-timeline :section-timeline="sectionTimeline" />
        <section-join-us />
        <!--        <section-join-our-team :sectionJoinOurTeam="sectionJoinOurTeam"/>-->
        <!--        <section-benefits :sectionBenefits="sectionBenefits"/>-->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
import SectionHero from '@web/pages/sections/AboutPage/SectionHero';
import SectionValues from '@web/pages/sections/AboutPage/SectionValues';
import SectionTimeline from '@web/pages/sections/AboutPage/SectionTimeline';
import SectionJoinUs from '@web/pages/sections/shared/SectionJoinUs';
// import SectionJoinOurTeam from '@web/pages/sections/AboutPage/SectionJoinOurTeam';
// import SectionBenefits from '@web/pages/sections/AboutPage/SectionBenefits';

export default {
  components: {
    Layout,
    SectionHero,
    SectionValues,
    SectionTimeline,
    SectionJoinUs,
    // SectionJoinOurTeam,
    // SectionBenefits,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
    },
    sectionValues: {
      type: Object,
      required: true,
    },
    sectionTimeline: {
      type: Object,
      required: true,
    },
    // sectionJoinOurTeam: {
    //     type: Object,
    //     required: true
    // },
    // sectionBenefits: {
    //     type: Object,
    //     required: false,
    // },
  },
};
</script>
